type DebouncedFunction<T extends unknown[], R> = (...args: T) => Promise<R> | R;

export function debounce<T extends unknown[], R>(
  fn: DebouncedFunction<T, R>,
  delay: number,
): DebouncedFunction<T, R> {
  let timer: NodeJS.Timeout;

  return function debounced(...args: T): Promise<R> | R {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;

    const execute = () => {
      clearTimeout(timer);
      return fn.apply(context, args);
    };

    clearTimeout(timer);

    if (delay <= 0) {
      return execute();
    }

    return new Promise<R>((resolve) => {
      timer = setTimeout(() => {
        resolve(execute());
      }, delay);
    });
  };
}
